import {Component} from '@angular/core';

@Component({
  selector: 'app-error-same-user',
  templateUrl: './error-same-user.component.html',
  styleUrls: ['./error-same-user.component.scss'],
})
export class ErrorSameUserComponent {}
